




















import { defineComponent, ref, useFetch, useRoute } from '@nuxtjs/composition-api';
import { SfImage, SfSection } from '@storefront-ui/vue';
import HTMLContent from '~/components/HTMLContent.vue';
import { useApi } from '~/composables';
import { buildSeoHead } from '~/helpers/buildSeoHead';
import articleGql from '../queries/article.gql';
import { Article, ArticlesQuery } from '../types';

export default defineComponent({
  name: 'ArticlePage',
  components: {
    SfSection,
    SfImage,
    HTMLContent,
  },
  setup() {
    const { query } = useApi();
    const route = useRoute();
    const {
      params: { parentSlug, slug },
    } = route.value;
    const article = ref<Article | null>(null);
    const slugToSend = parentSlug ? `${parentSlug}/${slug}` : `${slug}`;

    useFetch(async () => {
      const { data } = await query<ArticlesQuery>(articleGql, { slug: slugToSend });
      article.value = data.getArticles?.items?.[0];
    });
    return {
      article,
    };
  },
  head() {
    const article = this.article as Article | null;
    if (!article) {
      return null;
    }

    const description = article.summary?.html
      ? article.summary.html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
      : article.title;

    return buildSeoHead({
      title: article.title,
      description,
    });
  },
});
